export class SourceInfo {
  name: string;
  dsn: string;

  constructor(name: string, dsn: string) {
    this.name = name;
    this.dsn = dsn;
  }
}
